import TaTrainingVideos from '../../components/trainings/TaTrainingVideos';
import TrainingModals from '../../components/trainings/Modals';
import { createStore } from '../../components/trainings/store/store';
import { createApp } from 'vue';

const store = createStore();

if (document.getElementById('ta-training-videos')) {
    const app = createApp({
        components: {
            TaTrainingVideos,
            TrainingModals
        },
    });
    app.use(store);
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#ta-training-videos');
}


if (document.getElementById('ta-training-modals')) {
    const app2 = createApp({
        components: {
            TrainingModals
        }
    });
    
    app2.use(store);
    app2.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app2.mount('#ta-training-modals');
}
